import styled from "styled-components";

export const InfoLogin = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    padding: 20px;
    margin-top: 30px;
    background-color: #007ebd;

    span {
        font-weight: 600;
        font-size: .9rem;
    }

    a {
        display: flex;
        align-items: center;
        background: #fff;
        color: #181818;
        text-decoration: none;
        padding: 8px 10px;
        font-weight: 600;
        font-size: .8rem;
        border-radius: 5px;
        transition: all .3s ease;
    }

    a:hover {
        background: #ccc;
    }

    a i {
        margin-right: 5px;
    }
`

export const Container = styled.div `
    width: 100%;
    max-width: 1200px;
    margin: auto;
`

export const Header = styled.header `
    display: flex;
    align-items: center;

    button {
        height: 40px;
        width: 40px;
        border-radius: 50px;
        background: #404040;
        font-size: 1.1rem;
        cursor: pointer;
        color: #fff;
        border: none;
        margin-right: 10px;
        transition: all .3s ease;
    }

    button:hover {
        background: #505050;
    }

    h3 {
        font-size: 1.5rem;
    }
`

export const Main = styled.header `
    
    display: flex;
    flex-direction: column;
    margin: 50px 0;
    transition: all 1s ease;

    .section-loading-profile {
        display: flex;
        align-items: center;
        height: 100%;
    }
    
    ul {
        padding: 20px 0;
        margin-bottom: 20px;
    }

    .header-ul-configuracao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }

    .nome-configuracao {
        font-size: 1.1rem;
        font-weight: bold;
        text-transform: uppercase;
    }

    .descricao-configuracao {
        color: #ddd;
        font-size: .85rem;
        font-weight: 600;
    }

    .div-configuracoes a {
        color: #fff;
        font-size: .8rem;
        margin-top: 20px;
        border-bottom: 1px solid;
        transition: all .3s ease;
    }

    .div-configuracoes a:hover {
        color: #ccc;
    }

    .div-bt-qualidade-image {
        margin: 10px 0;
    }

    .div-bt-qualidade-image button {
        padding: 10px;
        font-weight: 600;
        background: #e50914;
        color: #fff;
        border: none;
        margin: 5px 5px 0 0;
        border-radius: 2px;
        cursor: pointer;
        transition: all .3s ease;
    }

    .div-bt-qualidade-image button:hover {
        opacity: .8;
    }

    .div-bt-qualidade-image button:last-child {
        margin-right: 0;
    }

    .bt-ativar-desativar-configuracao {
        position: relative;
        width: 40px;
        height: 20px;
        border-radius: 50px;
        border: none;
        background: #505050;
        cursor: pointer;
        margin-left: 10px;
        transition: all .3s ease;
    }

    .bt-ativar-desativar-configuracao div {
        position: absolute;
        top: 2.5px;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: #ccc;
        margin: 0 2px;
        transition: all .3s ease;
    }

    .bt-ativar-configuracao div {
        left: 1px;
    }

    .bt-desativar-configuracao {
        background: #e50914;
    }

    .bt-desativar-configuracao div {
        left: 20px;
        background: #fff;
    }

`